import envi from "./envi";
/**
 * @description 渠道/平台信息
 */
export const plat = {
    wx: {
        id: 501
    },
    qq: {
        id: 596
    },
    app: {
        id: 434
    },
    yPiao: {
        id: 860
    },
    other: {
        id: 501
    }
};

/**
 * @description 获取当前渠道/平台
 * @return {object}
 */
export const getCurrPlat = () => {
    if (envi.isInApp) return plat.app;
    else if (envi.isInYpiao) return plat.yPiao;
    else if (envi.isInWeixin) return plat.wx;
    else if (envi.isInQQ) return plat.qq;
    else return plat.other;
};

/**
 * @description 判断是否是小程序环境
 * @param {function} callback 回调方法 (isApplet) => {}
 */
export const isAppletEnvi = function (callback) {
    function ready() {
        callback && callback(window.__wxjs_environment === "miniprogram");
    }

    let av = navigator.appVersion || navigator.userAgent;

    if (!/MicroMessenger/.test(av) || av.length < 20) {
        // 区别PC端模拟
        ready();
        return;
    }

    if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
        document.addEventListener("WeixinJSBridgeReady", ready, false);
    } else {
        ready();
    }
};
